import { useMemo } from "react";
import "./property1-default.css";

const Property1Default = ({
  property1DefaultPosition,
  property1DefaultTop,
  property1DefaultLeft,
  property1DefaultBorderRadius,
  property1DefaultCursor,
  rectangleIconTop,
  onProject2ContainerClick,
}) => {
  const property1DefaultStyle = useMemo(() => {
    return {
      position: property1DefaultPosition,
      top: property1DefaultTop,
      left: property1DefaultLeft,
      borderRadius: property1DefaultBorderRadius,
      cursor: property1DefaultCursor,
    };
  }, [
    property1DefaultPosition,
    property1DefaultTop,
    property1DefaultLeft,
    property1DefaultBorderRadius,
    property1DefaultCursor,
  ]);

  const rectangleIconStyle = useMemo(() => {
    return {
      top: rectangleIconTop,
    };
  }, [rectangleIconTop]);

  return (
    <div
      className="property-1default"
      style={property1DefaultStyle}
      onClick={onProject2ContainerClick}
    >
      <div className="property-1default-child" />
      <div className="dised-website">diSed Website</div>
      <div className="a-central-hub">
        A central hub for effortless exploration and use of AI tools, saving you
        from the hassle of multiple websites and accounts.
      </div>
      <img
        className="rectangle-icon"
        alt=""
        src="/rectangle@2x.png"
        style={rectangleIconStyle}
      />
    </div>
  );
};

export default Property1Default;
